import { Component, Input } from '@angular/core';

import { StepHeaderTab } from './step-header-tab';

@Component({
  selector: 'nec-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss']
})

export class NecStepHeaderComponent {
  @Input() tabs: Array<StepHeaderTab>;

}
